/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Model_Region_GlobalInputs */



/**
* | output |
* | --- |
* | "No EU data residency" |
*
* @param {Uno_Settings_Model_Region_GlobalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_model_region_global = /** @type {((inputs?: Uno_Settings_Model_Region_GlobalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Model_Region_GlobalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine EU-Datenresidenz")
	return /** @type {LocalizedString} */ ("No EU data residency")
});